import { vEquipmentType } from '../equipment/utils.ts'
import {
  vArray,
  vCurrency,
  vDateUtcNoon,
  vMaxLength,
  vMinValue,
  vNumber,
  vNumberToString,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPipe,
  vString,
} from '../validation/index.ts'
import { updateChargeSchema } from './quote.ts'

export const upsertOpportunityQuoteSchema = vObject({
  quoteId: vOptional(vObjectId()),
  equipmentType: vEquipmentType(),
  amount: vPipe(vNumber(), vMinValue(0)),
  deliveryDate: vOptional(vDateUtcNoon()),
  quoteNum: vPipe(vNumberToString(), vMaxLength(50)),
  currency: vCurrency(),
  expirationDate: vOptional(vDateUtcNoon()), // TODO - is this used?
  charges: vOptional(vArray(updateChargeSchema)),
})

export type UpsertOpportunityQuoteDto = vOutput<
  typeof upsertOpportunityQuoteSchema
>

export const upsertOpportunityQuotesSchema = vObject({
  message: vOptional(vPipe(vString(), vMaxLength(500))),
  quotes: vArray(upsertOpportunityQuoteSchema),
})

export type UpsertOpportunityQuotesDto = vOutput<
  typeof upsertOpportunityQuotesSchema
>
